import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'

class ModalPresensiGuru extends Component {

    constructor(props) {
        super(props);

        this.handleToggle = this.handleToggle.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleToggle() {
        this.props.toggleModal()
    }

    handleSubmit() {
        this.props.handleSubmit()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div className="card-block">
                        <div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Guru</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.props.mapelGuru}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Lokasi</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.props.alamat_lokasi}</b></label>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleToggle}>Ok</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ModalPresensiGuru.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    toggleModal: PropTypes.func.isRequired,
    mapelGuru:PropTypes.string.isRequired,
    tracking_lat:PropTypes.string.isRequired,
    tracking_lng:PropTypes.string.isRequired,
    alamat_lokasi:PropTypes.string.isRequired,
}

export default ModalPresensiGuru


// WEBPACK FOOTER //
// ./src/components/ModalPresensiGuru.js